import {Box, Select} from '@mantine/core';
import {
  FOLLOW_COMPANY_RANKING_TERMS,
  FOLLOW_COMPANY_RANKING_TERM_LABELS,
} from '../../../../../core/entities/company/constants';
import type {FollowRankingListTermType} from '../../../../../core/entities/company/schema';
import {cn} from '../../../../../lib/classname';

type Props = {
  className?: string;
  rankingTerm: FollowRankingListTermType;
  setRankingTerm: (term: FollowRankingListTermType) => void;
  inTitleSection?: boolean;
};

export const FollowRankingTermSelector: React.FC<Props> = ({
  className,
  rankingTerm,
  setRankingTerm,
  inTitleSection = false,
}) => {
  return (
    <Box
      className={`${inTitleSection ? 'w-[112px]' : 'w-full'} border-line border-solid border-[1px] pc:border-[0px] pc:shadow-card pc:w-[112px] bg-white pc:py-8 pc:px-12 rounded-16 flex flex-col justify-center items-center ${cn(className)}`}
    >
      <Select
        variant="unstyled"
        className="w-full"
        value={rankingTerm}
        onChange={(val) => {
          setRankingTerm(val as FollowRankingListTermType);
        }}
        data={[
          {
            value: FOLLOW_COMPANY_RANKING_TERMS.all,
            label: FOLLOW_COMPANY_RANKING_TERM_LABELS.all,
          },
          {
            value: FOLLOW_COMPANY_RANKING_TERMS.daily,
            label: FOLLOW_COMPANY_RANKING_TERM_LABELS.daily,
          },
          {
            value: FOLLOW_COMPANY_RANKING_TERMS.weekly,
            label: FOLLOW_COMPANY_RANKING_TERM_LABELS.weekly,
          },
          {
            value: FOLLOW_COMPANY_RANKING_TERMS.monthly,
            label: FOLLOW_COMPANY_RANKING_TERM_LABELS.monthly,
          },
        ]}
        styles={{
          input: {
            paddingLeft: '12px',
            paddingRight: '12px',
          },
        }}
      />
    </Box>
  );
};
